var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#838383",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 23.2188L13.6562 15C13.0312 15.5417 12.3021 15.9635 11.4688 16.2656C10.6354 16.5677 9.75 16.7187 8.8125 16.7187C6.5625 16.7187 4.65625 15.9375 3.09375 14.375C1.53125 12.8125 0.75 10.9271 0.75 8.71875C0.75 6.51042 1.53125 4.625 3.09375 3.0625C4.65625 1.5 6.55208 0.71875 8.78125 0.71875C10.9896 0.71875 12.8698 1.5 14.4219 3.0625C15.974 4.625 16.75 6.51042 16.75 8.71875C16.75 9.61458 16.6042 10.4792 16.3125 11.3125C16.0208 12.1458 15.5833 12.9271 15 13.6562L23.25 21.8438L21.875 23.2188ZM8.78125 14.8437C10.4688 14.8437 11.9062 14.2448 13.0938 13.0469C14.2812 11.849 14.875 10.4062 14.875 8.71875C14.875 7.03125 14.2812 5.58854 13.0938 4.39062C11.9062 3.19271 10.4688 2.59375 8.78125 2.59375C7.07292 2.59375 5.61979 3.19271 4.42188 4.39062C3.22396 5.58854 2.625 7.03125 2.625 8.71875C2.625 10.4062 3.22396 11.849 4.42188 13.0469C5.61979 14.2448 7.07292 14.8437 8.78125 14.8437Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ed98249d52bef6232a3ec780e29ed115.svg";
export { ForwardRef as ReactComponent };